document.addEventListener('DOMContentLoaded', function () {
  const widgets = document.querySelectorAll(
    '.product-form-subscrption-badge'
  );

  widgets.forEach(function (widget) {
    if (widget.getAttribute('data-pp-widget-wired') === 'true') return;

    widget.setAttribute('data-pp-widget-wired', 'true');

    const oneTimeBox = widget.querySelector(
      '.product-form-single-subscrption'
    );

    const monthlyBox = widget.querySelector(
      '.product-form-monthly-subscrption'
    );

    const bundleBox = widget.querySelector(
      '.product-form-bundle-subscrption'
    );

    const oneTimeRadio =
      widget.querySelector('[data-pp-option="onetime"]') ||
      widget.querySelector('#onetime_purchase');

    const subRadio =
      widget.querySelector('[data-pp-option="subscription"]') ||
      widget.querySelector('#subscription_plan');

    const bundleRadio =
      widget.querySelector('[data-pp-option="bundle"]') ||
      widget.querySelector('#bundle_subscription');

    function getProductForm() {
      const directForm = widget.closest('form');

      if (directForm) return directForm;

      const productFormWrapper =
        widget.closest('product-form') ||
        widget.closest('.product-form') ||
        widget.closest('[data-product-form]');

      if (!productFormWrapper) return null;

      return (
        productFormWrapper.querySelector('form') ||
        productFormWrapper
      );
    }

    function getNearestFormElement() {
      const directForm = widget.closest('form');

      if (directForm) return directForm;

      const productForm = getProductForm();

      if (!productForm) return null;

      if (
        productForm.tagName &&
        productForm.tagName.toLowerCase() === 'form'
      ) {
        return productForm;
      }

      return productForm.querySelector('form');
    }

    function setSellingPlanValue(planIdOrEmpty) {
      const productForm = getProductForm();

      if (!productForm) return;

      const value = planIdOrEmpty || '';

      let sellingPlanInput =
        productForm.querySelector('.pp-selling-plan-hidden') ||
        productForm.querySelector(
          '[id^="pp-selling-plan-hidden-"]'
        ) ||
        productForm.querySelector(
          'input[type="hidden"][name="selling_plan"]'
        );

      if (!sellingPlanInput) {
        const formElement = getNearestFormElement();

        if (formElement) {
          sellingPlanInput = document.createElement('input');
          sellingPlanInput.type = 'hidden';
          sellingPlanInput.name = 'selling_plan';
          sellingPlanInput.className = 'pp-selling-plan-hidden';

          formElement.appendChild(sellingPlanInput);
        }
      }

      productForm
        .querySelectorAll('[name="selling_plan"]')
        .forEach(function (element) {
          if (element.type === 'radio') return;

          element.value = value;

          if (element.tagName === 'SELECT') {
            element.dispatchEvent(
              new Event('change', {
                bubbles: true
              })
            );
          } else {
            element.dispatchEvent(
              new Event('input', {
                bubbles: true
              })
            );

            element.dispatchEvent(
              new Event('change', {
                bubbles: true
              })
            );
          }
        });

      if (sellingPlanInput) {
        sellingPlanInput.value = value;
      }
    }

    function hideThemeQuantityUI() {
      const productForm = getProductForm();

      if (!productForm) return;

      const quantityInputs = productForm.querySelectorAll(
        'input[name="quantity"]'
      );

      quantityInputs.forEach(function (input) {
        const insideCustomQuantity = input.closest(
          '.quantity-section-wrapper'
        );

        if (insideCustomQuantity) return;

        const wrapper =
          input.closest('.product__quantity-wrapper') ||
          input.closest('.quantity-wrapper') ||
          input.closest('.product-form__quantity') ||
          input.closest('.quantity') ||
          input.parentElement;

        if (wrapper) {
          wrapper.style.display = 'none';
        }
      });
    }

    function clearActive() {
      widget
        .querySelectorAll('.subscription_content')
        .forEach(function (element) {
          element.classList.remove('active_subscription');
        });
    }

    function setSelectedState(state) {
      widget.setAttribute('data-selected-purchase', state);
    }

    function activateOneTime() {
      if (!oneTimeBox) return;

      clearActive();

      oneTimeBox.classList.add('active_subscription');

      if (oneTimeRadio) oneTimeRadio.checked = true;
      if (subRadio) subRadio.checked = false;
      if (bundleRadio) bundleRadio.checked = false;

      setSellingPlanValue('');
      setSelectedState('onetime');
    }

    function activateMonthly() {
      if (!monthlyBox) return;

      clearActive();

      monthlyBox.classList.add('active_subscription');

      if (subRadio) subRadio.checked = true;
      if (oneTimeRadio) oneTimeRadio.checked = false;
      if (bundleRadio) bundleRadio.checked = false;

      const monthlyPlanId =
        monthlyBox.getAttribute('data-selling-plan-id') || '';

      setSellingPlanValue(monthlyPlanId);
      setSelectedState('subscription');
    }

    function activateBundle() {
      if (!bundleBox) return;

      clearActive();

      bundleBox.classList.add('active_subscription');

      if (bundleRadio) bundleRadio.checked = true;
      if (oneTimeRadio) oneTimeRadio.checked = false;
      if (subRadio) subRadio.checked = false;

      /*
       * The 3-pack is a separate Shopify product.
       * We therefore clear the current product's selling plan.
       * The correct 3-pack variant and quarterly plan are added
       * separately through Shopify's AJAX cart API.
       */
      setSellingPlanValue('');
      setSelectedState('bundle');
    }

    function activateFromBox(box) {
      if (!box) return;

      if (
        box.classList.contains(
          'product-form-single-subscrption'
        )
      ) {
        activateOneTime();
      } else if (
        box.classList.contains(
          'product-form-monthly-subscrption'
        )
      ) {
        activateMonthly();
      } else if (
        box.classList.contains(
          'product-form-bundle-subscrption'
        )
      ) {
        activateBundle();
      }
    }

    function findAddButton(scope) {
      if (!scope) return null;

      return (
        scope.querySelector(
          'button[type="submit"][name="add"]'
        ) ||
        scope.querySelector('button[name="add"]') ||
        scope.querySelector('button[type="submit"]') ||
        scope.querySelector('input[type="submit"]')
      );
    }

    function findAddButtonWrapper(addButton) {
      if (!addButton) return null;

      const selectors = [
        '.product-form__buttons',
        '.product-form-buttons',
        '.product-form__actions',
        '.product-form__submit-wrapper',
        '.product-form-submit',
        '.product-form__cart-submit-wrapper',
        '.product-form__controls-group--submit',
        '.payment-buttons',
        '.add-to-cart-wrapper',
        '.product-form--atc'
      ];

      for (let index = 0; index < selectors.length; index++) {
        const wrapper = addButton.closest(selectors[index]);

        if (wrapper && !wrapper.contains(widget)) {
          return wrapper;
        }
      }

      return addButton;
    }

    function moveAddToCartBelowWidget() {
      const formElement = getNearestFormElement();

      if (!formElement || !formElement.contains(widget)) return;

      const addButton = findAddButton(formElement);

      if (!addButton) return;

      const addButtonWrapper =
        findAddButtonWrapper(addButton);

      if (
        !addButtonWrapper ||
        addButtonWrapper.contains(widget)
      ) {
        return;
      }

      if (!formElement.contains(addButtonWrapper)) return;

      addButtonWrapper.classList.add(
        'pp-add-to-cart-after-options'
      );

      if (widget.nextElementSibling !== addButtonWrapper) {
        widget.insertAdjacentElement(
          'afterend',
          addButtonWrapper
        );
      }
    }

    function getBundleSelection() {
      if (!bundleBox) {
        throw new Error(
          'The quarterly bundle option could not be found.'
        );
      }

      /*
       * These two values must be printed by Liquid:
       *
       * data-bundle-variant-id
       * data-bundle-selling-plan-id
       */
      const variantId = Number(
        bundleBox.getAttribute('data-bundle-variant-id')
      );

      const sellingPlanId = Number(
        bundleBox.getAttribute(
          'data-bundle-selling-plan-id'
        )
      );

      if (!variantId) {
        const handle =
          bundleBox.getAttribute('data-bundle-handle') ||
          'ruba-menopause-relief-pack-of-3';

        throw new Error(
          'The 3-pack product could not be loaded. Verify that the Shopify handle is "' +
            handle +
            '" and that the product is published to the Online Store.'
        );
      }

      if (!sellingPlanId) {
        throw new Error(
          'The quarterly selling plan could not be found for the 3-pack product. Verify the Easy Subscriptions setup and make sure the plan is assigned to the 3-pack variant.'
        );
      }

      return {
        variantId: variantId,
        sellingPlanId: sellingPlanId
      };
    }

    function setButtonLoading(isLoading) {
      const productForm = getProductForm();
      const addButton = findAddButton(productForm);

      if (!addButton) return;

      if (isLoading) {
        if (!addButton.dataset.ppOriginalText) {
          addButton.dataset.ppOriginalText =
            addButton.textContent.trim();
        }

        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');

        if (addButton.tagName === 'INPUT') {
          addButton.value = 'Adding...';
        } else {
          addButton.textContent = 'Adding...';
        }
      } else {
        addButton.disabled = false;
        addButton.removeAttribute('aria-busy');

        const originalText =
          addButton.dataset.ppOriginalText;

        if (originalText) {
          if (addButton.tagName === 'INPUT') {
            addButton.value = originalText;
          } else {
            addButton.textContent = originalText;
          }
        }
      }
    }

    async function addBundleToCartAndRedirect() {
      if (!bundleBox) return false;

      const redirectTo =
        bundleBox.getAttribute('data-bundle-redirect') ||
        '/cart';

      const bundleData = getBundleSelection();

      const payload = {
        items: [
          {
            id: bundleData.variantId,
            quantity: 1,
            selling_plan: bundleData.sellingPlanId
          }
        ]
      };

      const shopifyRoot =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      setButtonLoading(true);

      try {
        const response = await fetch(
          shopifyRoot + 'cart/add.js',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          let errorMessage =
            'Unable to add the quarterly subscription to the cart.';

          try {
            const errorData = await response.json();

            errorMessage =
              errorData.description ||
              errorData.message ||
              errorMessage;
          } catch (jsonError) {
            const errorText = await response.text();

            if (errorText) {
              errorMessage = errorText;
            }
          }

          throw new Error(errorMessage);
        }

        window.location.href = redirectTo;

        return true;
      } finally {
        /*
         * This only runs if the redirect has not happened,
         * usually because an error occurred.
         */
        setButtonLoading(false);
      }
    }

    let bundleRequestRunning = false;

    async function handleBundleAdd(event) {
      const bundleActive = widget.querySelector(
        '.product-form-bundle-subscrption.active_subscription'
      );

      if (!bundleActive) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (bundleRequestRunning) return;

      bundleRequestRunning = true;

      try {
        activateBundle();
        await addBundleToCartAndRedirect();
      } catch (error) {
        console.error(
          '[Ruba purchase options]',
          error
        );

        window.alert(
          error.message ||
            'Unable to add the quarterly subscription. Please try again.'
        );
      } finally {
        bundleRequestRunning = false;
      }
    }

    function wireBundleIntercepts() {
      const productForm = getProductForm();

      if (!productForm) return;

      const addButton = findAddButton(productForm);

      if (addButton) {
        addButton.addEventListener(
          'click',
          handleBundleAdd,
          true
        );
      }

      productForm.addEventListener(
        'submit',
        handleBundleAdd,
        true
      );
    }

    hideThemeQuantityUI();
    activateMonthly();

    setTimeout(function () {
      hideThemeQuantityUI();
      activateMonthly();
      moveAddToCartBelowWidget();
    }, 400);

    setTimeout(function () {
      moveAddToCartBelowWidget();
    }, 1200);

    widget
      .querySelectorAll('.subscription_content')
      .forEach(function (box) {
        box.addEventListener('click', function (event) {
          const ignoredElement = event.target.closest(
            'a, button, input[type="number"], .quantity-button'
          );

          if (ignoredElement) return;

          activateFromBox(box);
        });
      });

    widget
      .querySelectorAll('.subscription_label')
      .forEach(function (label) {
        label.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          const parent = this.closest(
            '.subscription_content'
          );

          activateFromBox(parent);
        });
      });

    widget
      .querySelectorAll('.outer_checkbox')
      .forEach(function (checkbox) {
        checkbox.addEventListener(
          'click',
          function (event) {
            event.preventDefault();
            event.stopPropagation();

            const parent = this.closest(
              '.subscription_content'
            );

            activateFromBox(parent);
          }
        );
      });

    if (oneTimeRadio) {
      oneTimeRadio.addEventListener(
        'change',
        function () {
          if (this.checked) {
            activateOneTime();
          }
        }
      );
    }

    if (subRadio) {
      subRadio.addEventListener(
        'change',
        function () {
          if (this.checked) {
            activateMonthly();
          }
        }
      );
    }

    if (bundleRadio) {
      bundleRadio.addEventListener(
        'change',
        function () {
          if (this.checked) {
            activateBundle();
          }
        }
      );
    }

    wireBundleIntercepts();
  });
});